import { render, staticRenderFns } from "./integralDetail.vue?vue&type=template&id=351fa098"
import script from "./integralDetail.vue?vue&type=script&lang=js"
export * from "./integralDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports